export default "__VITE_ASSET__ztUPfeJR__"